/* PDP transparent header — fill on scroll (mobile only).
 *
 * The PDP header is transparent so the product gallery reaches the top of the
 * viewport. Without this, the header stays transparent while scrolling and the
 * page content slides under the logo. This watches the product gallery with an
 * IntersectionObserver and toggles the theme's existing `.is-filled` state on
 * the <store-header> once the gallery scrolls out of the header zone, so the
 * header regains its solid background before content reaches it.
 *
 * Using an observer on the actual gallery (rather than a fixed scroll value)
 * means the transition point auto-adapts to the gallery height on any device.
 */
(function () {
  function init() {
    if (!window.matchMedia('(max-width: 999px)').matches) return;
    if (!('IntersectionObserver' in window)) return;

    var header = document.querySelector('store-header');
    var gallery = document.querySelector('.product-gallery');
    if (!header || !gallery) return;

    var observer;

    function connect() {
      // Shrink the observation root by the header height so the gallery counts
      // as "out of view" exactly when its bottom passes below the header bar.
      var headerHeight = header.offsetHeight || 0;
      observer = new IntersectionObserver(function (entries) {
        header.classList.toggle('is-filled', !entries[0].isIntersecting);
      }, { rootMargin: '-' + headerHeight + 'px 0px 0px 0px', threshold: 0 });
      observer.observe(gallery);
    }

    connect();

    // Recompute on resize/orientation change; drop the filled state on desktop.
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (observer) observer.disconnect();
        if (!window.matchMedia('(max-width: 999px)').matches) {
          header.classList.remove('is-filled');
          return;
        }
        connect();
      }, 200);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
